import { render, staticRenderFns } from "./RegistrationReportTable.vue?vue&type=template&id=3985d454&scoped=true"
import script from "./RegistrationReportTable.vue?vue&type=script&lang=js"
export * from "./RegistrationReportTable.vue?vue&type=script&lang=js"
import style0 from "./RegistrationReportTable.vue?vue&type=style&index=0&id=3985d454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3985d454",
  null
  
)

export default component.exports